// The web motion scale from theme/studio-motion.css, for framer-motion, which takes
// seconds and cubic-bezier arrays instead of the CSS variables. Keep the values
// in step with the motion block there.
export const motionDuration = {
    instant: 0.08,
    quick: 0.15,
    standard: 0.25,
    deliberate: 0.4,
    emphasis: 0.5,
} as const;

type CubicBezier = readonly [number, number, number, number];

export const motionEase: {
    /** The house curve: movement that stays on screen. */
    readonly standard: CubicBezier;
    /** Smooth-out: surfaces appearing or leaving. */
    readonly enter: CubicBezier;
    /** Notification badges only. */
    readonly bounce: CubicBezier;
} = {
    standard: [0.2, 0, 0, 1],
    enter: [0.22, 1, 0.36, 1],
    bounce: [0.34, 1.36, 0.64, 1],
};
